import React from "react";

import SlideOutModal from "./SlideOutModal";
import SlideOutModalSuccess from "./SlideOutModalSuccess";
import SlideOutModalFail from "./SlideOutModalFail";

const SuccessFailSlideOutModal = ({
  children,
  title,
  onClose,
  onSuccessClose,
  buttons,
  stepSection,
  className,
  width,
  isSuccess,
  isFail,
  successMessage,
  failMessage,
  caseNumber,
  customSuccessPage,
  customFailPage,
  onBack,
  error,
}) => (
  <SlideOutModal
    title={title}
    onClose={onClose}
    buttons={!isFail && !isSuccess && buttons}
    stepSection={!isFail && !isSuccess && stepSection}
    className={className}
    width={width}
  >
    {error && <div className="modal-top-error-message">{error}</div>}
    {isSuccess
      ? customSuccessPage || (
          <SlideOutModalSuccess
            onBack={onSuccessClose || onBack || onClose}
            message={successMessage}
          />
        )
      : isFail
      ? customFailPage || (
          <SlideOutModalFail
            onBack={onBack || onClose}
            message={failMessage}
            caseNumber={caseNumber}
          />
        )
      : children}
  </SlideOutModal>
);

export default SuccessFailSlideOutModal;
